import { Pill, type PillVariant } from "@/components/podkit/status/Pill";
import type { PlainWorkflowExecutionAction } from "@/queries/automation-queries";
import { hasWorkflowExecutionActionFailed, workflowExecutionActionPhaseLabel } from "@/utils/automation-execution-action";
import { WorkflowExecutionActionPhase } from "gitpod-next-api/gitpod/v1/workflow_pb";
import type { FC } from "react";

export const WorkflowExecutionActionStatusPill: FC<{ action: PlainWorkflowExecutionAction }> = ({ action }) => {
    const variant = variantFromPhase(action);
    return (
        <Pill variant={variant} size={"lg"} className="w-fit">
            {workflowExecutionActionPhaseLabel(action)}
        </Pill>
    );
};

function variantFromPhase(action: PlainWorkflowExecutionAction): PillVariant {
    const failed = hasWorkflowExecutionActionFailed(action);
    switch (action.status?.phase) {
        case WorkflowExecutionActionPhase.PENDING:
        case WorkflowExecutionActionPhase.UNSPECIFIED:
        case WorkflowExecutionActionPhase.RUNNING:
        case WorkflowExecutionActionPhase.STOPPING:
        case WorkflowExecutionActionPhase.STOPPED:
        case WorkflowExecutionActionPhase.DELETING:
        case WorkflowExecutionActionPhase.DELETED:
            return "info";
        case WorkflowExecutionActionPhase.DONE:
            return failed ? "warning" : "success";
    }
}
